import React from "react";

export const SEChevronLeft = ({ color = "#222222", ...props }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			color={color}
			{...props}
		>
			<path
				d="M3.49949 6.70021C3.49949 6.91528 3.58161 7.13032 3.74549 7.29428L8.90529 12.454C9.23352 12.7823 9.76568 12.7823 10.0938 12.454C10.4219 12.1259 10.4219 11.5939 10.0938 11.2656L5.5281 6.70021L10.0936 2.13478C10.4217 1.80656 10.4217 1.27455 10.0936 0.946485C9.76552 0.618098 9.23336 0.618098 8.90513 0.946485L3.74533 6.10614C3.58142 6.27019 3.49949 6.48523 3.49949 6.70021Z"
				fill="currentColor"
			/>
		</svg>
	);
};
